import {fromJS, Map} from 'immutable';
import dieselReducer from 'epic-diesel-common/src/decorators/DieselReducer';
import taxActions from '../../actions/tax.actions';
import {TaxState} from './types';

const initialState: TaxState = {
    loading: false,
    loadingRecord: false,
    organizations: [],
    record: null,
    isOrg: false,
    taxInterviewUrl: null,
    payAble: false,
    isConsent: true,
    submitted: false,
    createAble: false,
    retakeAvailable: false,
    dialogError: null,
    syncAvailable: false,
    isOffline: false,
    accountStatus: null,
    loadingTaxInfo: false,
    taxStatus: null,
    taxCountrySanctioned: false,
    hyperWalletData: {
        linkEnable: false,
        expireTime: null,
        link: null
    },
    payoutProviderType: null,
    organizationEmail: null
};

export const DEFAULT_STATE = fromJS(initialState);

export const taxReducer = (state: Map<keyof TaxState, any> = DEFAULT_STATE, action) => {
    let newState = state;
    switch (action.type) {
        case taxActions.TYPES.GET_CONSENT: {
            return newState;
        }

        case taxActions.TYPES.GET_CONSENT_COMPLETE: {
            newState = newState.updateIn(['isConsent'], () => action.payload.data);
            return newState;
        }

        case taxActions.TYPES.GET_CONSENT_FAILED: {
            newState = newState.updateIn(['isConsent'], () => action.payload.data);
            return newState;
        }

        case taxActions.TYPES.GET_RECORD_RETAKE_UPDATE_COMPLETE: {
            const {syncAvailable, retakeAvailable} = action.payload.data;
            newState = newState.updateIn(['retakeAvailable'], () => retakeAvailable);
            newState = newState.updateIn(['syncAvailable'], () => syncAvailable);
            return newState;
        }

        case taxActions.TYPES.GET_RECORD_RETAKE_UPDATE_FAILED: {
            newState = newState.updateIn(['retakeAvailable'], () => false);
            newState = newState.updateIn(['syncAvailable'], () => false);
            return newState;
        }

        case taxActions.TYPES.GET_BALANCE_PAYABLE: {
            newState = newState.updateIn(['payAble'], () => false);
            return newState;
        }

        case taxActions.TYPES.GET_BALANCE_PAYABLE_COMPLETE: {
            newState = newState.updateIn(['payAble'], () => action.payload.data);
            newState = newState.updateIn(['loading'], () => false);
            return newState;
        }

        case taxActions.TYPES.GET_BALANCE_PAYABLE_FAILED: {
            newState = newState.updateIn(['loading'], () => false);
            return newState;
        }

        case taxActions.TYPES.RETAKE_INTERVIEW: {
            newState = newState.updateIn(['loading'], () => true);
            return newState;
        }

        case taxActions.TYPES.RETAKE_INTERVIEW_COMPLETE: {
            newState = newState.updateIn(['loading'], () => false);
            newState = newState.updateIn(['taxInterviewUrl'], () => action.payload.data);
            return newState;
        }

        case taxActions.TYPES.RETAKE_INTERVIEW_FAILED: {
            if (action.payload.response.data && action.payload.response.data.statusMessage) {
                newState = newState.updateIn(
                    ['dialogError'],
                    () => action.payload.response.data.statusMessage
                );
            }
            newState = newState.updateIn(['loading'], () => false);
            return newState;
        }

        case taxActions.TYPES.GET_RECORD_EMAIL: {
            newState = newState.updateIn(['loading'], () => true);
            return newState;
        }

        case taxActions.TYPES.GET_RECORD_EMAIL_COMPLETE: {
            newState = newState.updateIn(['loading'], () => false);
            if (action.payload.data) {
                newState = newState.updateIn(['organizationEmail'], () => action.payload.data);
            } else {
                newState = newState.updateIn(['organizationEmail'], () => '');
            }
            return newState;
        }

        case taxActions.TYPES.GET_TAX_RECORD: {
            newState = newState.updateIn(['loadingRecord'], () => true);
            return newState;
        }

        case taxActions.TYPES.GET_TAX_RECORD_COMPLETE: {
            newState = newState.updateIn(['loadingRecord'], () => false);
            const record = action.payload.data;
            if (record) {
                newState = newState.updateIn(['submitted'], () => !!record.recordIdentityKey);
                newState = newState.updateIn(['validated'], () => record.taxVerified);
                const isOffline = record.taxVerified && record.paymentHandler === 'epic';
                newState = newState.updateIn(['isOffline'], () => isOffline);
                newState = newState.updateIn(['createAble'], () => true);
            } else {
                newState = newState.updateIn(['createAble'], () => false);
            }
            newState = newState.updateIn(['record'], () => record);
            return newState;
        }

        case taxActions.TYPES.GET_TAX_RECORD_FAILED: {
            newState = newState.updateIn(['createAble'], () => false);
            newState = newState.updateIn(['loadingRecord'], () => false);
            return newState;
        }

        case taxActions.TYPES.GET_TAX_INTERVIEW: {
            newState = newState.updateIn(['loading'], () => true);
            return newState;
        }
        case taxActions.TYPES.GET_TAX_INTERVIEW_COMPLETE: {
            newState = newState.updateIn(['loading'], () => false);
            newState = newState.updateIn(['taxInterviewUrl'], () => action.payload.data);
            return newState;
        }

        case taxActions.TYPES.GET_TAX_INTERVIEW_FAILED: {
            if (action.payload.response.data && action.payload.response.data.statusMessage) {
                newState = newState.updateIn(
                    ['dialogError'],
                    () => action.payload.response.data.statusMessage
                );
            }
            newState = newState.updateIn(['loading'], () => false);
            return newState;
        }

        case taxActions.TYPES.REFRESH_TAX_RECORD: {
            newState = newState.updateIn(['loading'], () => true);
            return newState;
        }

        case taxActions.TYPES.REFRESH_TAX_RECORD_COMPLETE: {
            const record = action.payload.data;
            newState = newState.updateIn(['loading'], () => false);
            if (record) {
                newState = newState.updateIn(['submitted'], () => !!record.recordIdentityKey);
                newState = newState.updateIn(['validated'], () => record.taxVerified);
            }
            newState = newState.updateIn(['record'], () => record);
            newState = newState.updateIn(['syncAvailable'], () => false);
            return newState;
        }

        case taxActions.TYPES.REFRESH_TAX_RECORD_FAILED: {
            newState = newState.updateIn(['loading'], () => false);
            return newState;
        }

        case taxActions.TYPES.UPDATE_TAX_RECORD: {
            newState = newState.updateIn(['loading'], () => true);
            newState = newState.updateIn(['record'], () => action.payload);
            return newState;
        }

        case taxActions.TYPES.UPDATE_TAX_RECORD_COMPLETE: {
            newState = newState.updateIn(['loading'], () => false);
            const record = action.payload.data;
            if (record) {
                newState = newState.updateIn(['submitted'], () => !!record.recordIdentityKey);
                newState = newState.updateIn(['validated'], () => record.taxVerified);
            }
            newState = newState.updateIn(['record'], () => record);
            return newState;
        }

        case taxActions.TYPES.UPDATE_TAX_RECORD_FAILED: {
            newState = newState.updateIn(['loading'], () => false);
            return newState;
        }

        case taxActions.TYPES.CONSENT_FOR_PAYMENT: {
            return newState;
        }

        case taxActions.TYPES.CONSENT_FOR_PAYMENT_COMPLETE: {
            newState = newState.updateIn(['loading'], () => false);
            newState = newState.updateIn(['taxInterviewUrl'], () => action.payload.data);
            return newState;
        }

        case taxActions.TYPES.CONSENT_FOR_PAYMENT_FAILED: {
            newState = newState.updateIn(['loading'], () => false);
            return newState;
        }

        case taxActions.TYPES.RESET_INTERVIEW: {
            newState = newState.updateIn(['taxInterviewUrl'], () => '');
            return newState;
        }

        case taxActions.TYPES.RESET_DIALOG: {
            newState = newState.updateIn(['dialogError'], () => '');
            return newState;
        }

        case taxActions.TYPES.GET_ORGANIZATIONS_COMPLETE: {
            const {data} = action.payload;
            if (data.length) {
                newState = newState.updateIn(['organizations'], () =>
                    data.map(org => ({...org, organizationId: org.id}))
                );
            }
            newState = newState.updateIn(['loading'], () => false);
            newState = newState.updateIn(['isOrg'], () => !!data.organizationEntity);
            return newState;
        }
        case taxActions.TYPES.GET_ORGANIZATIONS_FAILED:
            newState = newState.updateIn(['loading'], () => false);
            return newState;

        case taxActions.TYPES.GET_PAYOUT_ACCOUNT_STATUS: {
            newState = newState.updateIn(['loading'], () => true);
            return newState;
        }

        case taxActions.TYPES.GET_PAYOUT_ACCOUNT_STATUS_COMPLETE: {
            const resp = action.payload.data || {};
            newState = newState.updateIn(['loading'], () => false);
            newState = newState.updateIn(['accountStatus'], () => resp.accountStatus);
            if (resp.payoutProviderType) {
                newState = newState.updateIn(['payoutProviderType'], () => resp.payoutProviderType);
            }
            return newState;
        }

        case taxActions.TYPES.GET_PAYOUT_ACCOUNT_STATUS_FAILED: {
            newState = newState.updateIn(['loading'], () => false);
            return newState;
        }

        case taxActions.TYPES.GET_HYPERWALLET_ACTIVE_LINK: {
            newState = newState.updateIn(['loading'], () => true);
            return newState;
        }

        case taxActions.TYPES.GET_HYPERWALLET_ACTIVE_LINK_COMPLETE: {
            const resp = action.payload.data;
            newState = newState.updateIn(['loading'], () => false);
            newState = newState.updateIn(['hyperWalletData'], () => resp);
            return newState;
        }

        case taxActions.TYPES.GET_HYPERWALLET_ACTIVE_LINK_FAILED: {
            newState = newState.updateIn(['loading'], () => false);
            return newState;
        }

        case taxActions.TYPES.GET_TAX_STATUS: {
            newState = newState.updateIn(['loadingTaxInfo'], () => true);
            return newState;
        }

        case taxActions.TYPES.GET_TAX_STATUS_SUCCESS: {
            const {data = {}} = action.payload || {};
            const {hyperWalletData, taxStatus, taxCountrySanctioned = false} = data;
            newState = newState.updateIn(['hyperWalletData'], () => hyperWalletData);
            newState = newState.updateIn(['taxStatus'], () => taxStatus);
            newState = newState.updateIn(['taxCountrySanctioned'], () => taxCountrySanctioned);
            newState = newState.updateIn(['loadingTaxInfo'], () => false);
            return newState;
        }

        case taxActions.TYPES.GET_TAX_STATUS_FAILED: {
            newState = newState.updateIn(['loadingTaxInfo'], () => false);
            return newState;
        }

        case taxActions.TYPES.RESET_LOADING: {
            newState = newState.updateIn(['loadingRecord'], () => true);
            return newState;
        }

        default:
            return state;
    }
};

export default dieselReducer('tax', taxReducer);
